const cleanInput = (val: unknown): string =>
  typeof val === 'string' ? val.toLowerCase().trim() : '';

export default cleanInput;
